import { useRef } from "react";
import useListbox from "./useListbox";
import useRefCallback from "./useRefCallback";
import useScrollIntoView from "./useScrollIntoView";

export default function useScrollingListbox(
	length: number,
	bodyClassName: string,
	callback?: () => void
) {
	// sets reference of list items parent
	const bodyRef = useRef<HTMLDivElement>(null);

	// uses useRefCallback so that itemRef is always in sync with currentActive so that scroll works properly
	const [itemRef, refCallback] = useRefCallback();

	// sets up the keyboard bindings
	const { currentActive, setCurrentActive, handleKeyDown } = useListbox(
		length,
		callback
	);

	// tracks whether the active item is in view
	useScrollIntoView(
		currentActive,
		bodyRef.current?.closest(`.${bodyClassName}`),
		itemRef
	);

	return {
		currentActive,
		setCurrentActive,
		handleKeyDown,
		refCallback,
		bodyRef,
	};
}
